var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProviderstats = function SvgProviderstats(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 24V8C29.3333 6.52724 28.1393 5.33334 26.6666 5.33334L5.33325 5.33334C3.86049 5.33334 2.66658 6.52724 2.66658 8V24C2.66658 25.4728 3.86049 26.6667 5.33325 26.6667H26.6666C28.1393 26.6667 29.3333 25.4728 29.3333 24Z",
    stroke: "#3C8DBC",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 14C9.33337 14.7072 9.6142 15.3855 10.1143 15.8856C10.6144 16.3857 11.2928 16.6667 12 16.6667C12.7073 16.6667 13.3854 16.3857 13.8855 15.8856C14.3856 15.3855 14.6667 14.7072 14.6667 14V12.6667C14.6667 11.9594 14.3856 11.2811 13.8855 10.781C13.3854 10.2809 12.7073 10 12 10C11.2928 10 10.6144 10.2809 10.1143 10.781C9.6142 11.2811 9.33337 11.9594 9.33337 12.6667V14Z",
    fill: "#3C8DBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 22C16.957 20.8698 16.2446 19.8813 15.2916 19.1665C14.3386 18.4518 13.1904 18.0448 12 18C10.8096 18.0448 9.66128 18.4518 8.70829 19.1665C7.7553 19.8813 7.04296 20.8698 6.66663 22",
    fill: "#3C8DBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 13.3333H18.6666",
    stroke: "#3C8DBC",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 18.6667H18.6666",
    stroke: "#3C8DBC",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProviderstats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Providerstats.014de0b0de662158d8ea9b89f4b3b6e1.svg";